import {Component, OnInit, Output, EventEmitter, ViewChild, OnDestroy} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {ObjectsApiService} from '../../../../api/src/object/objects-api.service';
import {filter} from 'rxjs/operators';
import {matchActionStatus} from '../../../../api/src/reactive-service.abstract';
import {UnitsApiService} from '../../../../api/src/unit/units-api.service';
import {ObjectModel} from '../../../../api/src/object/object.model';

@Component({
    selector: 'app-compose-units-modal',
    templateUrl: './compose-units-modal.component.html',
    styleUrls: ['./compose-units-modal.component.scss'],
    standalone: false
})
export class ComposeUnitsModalComponent implements OnInit, OnDestroy {


  @Output() select = new EventEmitter();
  @Output() close = new EventEmitter();

  @ViewChild('unitlist', { static: true }) unitlist;
  @ViewChild('appobjectpage', { static: true }) appobjectpage;

  public selectedObject: ObjectModel;
  public selectedParams = [];
  public options = [];
  public disabledParams = [];
  public isLoading = new BehaviorSubject(false);

  private returnParams = false;
  subscriptions: any = [];
  excludeColumnsObjectForm = ['objectType', 'hierarchyInstance', 'hierarchyExport', 'fullname', 'timezone', 'area', 'latitude', 'longitude', 'employees',
    'sdirobjectstate', 'calendar', 'address', 'comment', 'controllerstate', 'worstparamstate', 'status'];
  showCog = false;

  query: string = undefined;
  limit: number = 255;
  extCommand = true;
  simpleForm = false;
  singleSelection = false;
  useSimpleObjectTree = false;
  flexScroll = true;
  stickyTableHeader = false;
  private selectionMode = '';

  constructor(public ref: DynamicDialogRef,
              public config: DynamicDialogConfig,
              private objectsApi: ObjectsApiService,
              private unitsApi: UnitsApiService,
              ) {
  }

  ngOnInit() {
    this.selectedParams = this.config.data.selectedParams || [];
    this.returnParams = this.config.data.config?.returnParams || false;
    this.query = this.config.data.config?.query || undefined;
    this.limit = this.config.data.config?.limit || undefined;
    this.extCommand = this.config.data.config?.extCommand === true;
    this.simpleForm = this.config.data.options?.simpleForm === false;
    this.singleSelection = this.config.data.options?.singleSelection === true;
    this.useSimpleObjectTree = this.config.data.config?.useSimpleObjectTree === true;
    this.flexScroll = this.config.data.config?.flexScroll !== false;
    this.stickyTableHeader = this.config.data.config?.stickyTableHeader === true;

    this.options = this.config.data.options;
    this.selectionMode = this.config.data.config?.selectionMode;
    this.selectedObject = this.config.data.options?.selectedObject;
    this.appobjectpage.selectedObject = this.selectedObject;
    this.disabledParams = this.config.data.disabledParams || [];
    this.subscriptions = [
      this.objectsApi.events.pipe(filter(matchActionStatus('single', ['selectGroup']))).subscribe(
        data => {
          this.unitlist.oidQuery = data.action.params.objlist.map(o => 'oid=' + o.id).join('&');
          if (this.limit) {
            this.unitlist.oidLimit = `${this.limit}`;
          }
          this.unitlist.oidExtCommand = this.extCommand;
          if (this.query) {
            this.unitlist.oidQuery += '&' + this.query;
          }
          try {
            if (data.action.params.objlist.length > 0) {
              this.unitlist.loadData(this.unitlist.incrementInd());
            } else {
              this.unitlist.changeFilter();
            }
          } catch (e) { console.error(e); }
        }
      ),
      this.unitsApi.events.pipe(filter(matchActionStatus('error', ['update']))).subscribe((data) => {
        // do nothing
      }),
      this.unitsApi.events.pipe(filter(matchActionStatus('done', ['update']))).subscribe(data => {
        this.ref.close(null);
      })
    ];
  }


  next() {
    this.unitlist.selected = !this.unitlist.selected?.id ? this.unitlist.selected.filter(s => s?.id) : [this.unitlist.selected];
    const ids = this.unitlist.selected.map(s => +s.id);
    const names = this.unitlist.selected.map(s => s.devicename);
    const params =  this.unitlist.getSelectedFromApi(ids, names);

    if (this.returnParams) {
      this.ref.close(params);
      return;
    }

    if (params && params.length > 0) {
      /*this.unitsApi.sendEvent(
        {name: 'save'},
        this.unitsApi.add(params)
      );*/
    }

    // this.ref.close({params: this.unitlist.getSelectedFromApi(ids)});
  }

  ngOnDestroy() {
    this.subscriptions.forEach(_subscription => _subscription.unsubscribe());
  }


  closeModal(paramsList = null) {
    this.ref.close(null);
  }
}
